export default __webpack_public_path__ + "static/media/contactcenterEmpty.662a705b.svg";